import cn from 'clsx'
import s from './ScanningSection.module.scss'
import { FC, useRef } from 'react'
import {
  Text,
  CustomImage,
  Container,
  Button,
  VideoPlayer,
} from '@components/ui'

import { Product } from '@commerce/types/product'
// import ProductCard from './ProductCard/ProductCard'
import { LoreThreePage } from '@generated/model/loreThreePage'
import { ControlBar, Player, PlayerReference } from 'video-react'
import ScanningBlock from './ScanningBlock'
import { ProductSlider } from '@components/product'
import { CustomImageProps } from '@components/ui/CustomImage/CustomImage'

type ScanningSectionProps = {
  page: LoreThreePage
}

const ScanningSection: FC<ScanningSectionProps> = ({ page }) => {
  if (page.scanning_section == null) return null
  const source =
    page.scanning_section.video || page.scanning_section.video_url
  return (
    <>
      <Container>
        <section className={s.root}>
          <div className={cn(s.grid)}>
            <Text variant="pageHeading" className={s.title}>
              {page.scanning_section.title}
            </Text>

            {source && (
              <VideoPlayer
                data={page.scanning_section}
                controls={page.scanning_section.controls || false}
                className={s.videoContainer}
                preload="metadata"
              />
            )}

            <ProductSlider
              disabledOnDesktop={true}
              //   currentSlide={currentSlide}
              showNavigation={false}
              perView={1.2}
              spacing={20}
              className={s.slider}
              childClassName={s.blocks}
            >
              {page.scanning_blocks?.map((block, index) => (
                <div key={block.id}>
                  <ScanningBlock
                    key={block.id}
                    block={block}
                    index={index + 1}
                  />
                </div>
              ))}

              <></>
            </ProductSlider>

            <Button
              className={s.button}
              Component="a"
              href={page.scanning_section.link_url}
            >
              {page.scanning_section.link_text}
            </Button>
          </div>
        </section>
      </Container>
    </>
  )
}

export default ScanningSection
